var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoaaDigitalLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0085ca;}.cls-2{fill:#fff;}.cls-3{fill:#003087;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Digital_Logo",
    "data-name": "Digital Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "For_Print",
    "data-name": "For Print"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Water",
    className: "cls-1",
    d: "M70.17,20.61c-5.27,7.93-14,19-24.19,22.69l-1.26.53a2.86,2.86,0,0,0,.77.23h1.2c2.58-.1,6.3-1.19,7.06,1.43A30.55,30.55,0,0,0,39,49.41c-4.61,2.53-10.45,4.81-14.27,1.26,3.06-.41,8.71-2.26,10.7-4.07C19.25,46.38,12.06,36.3,7,30.79c-1.82-2.11-3.69-3.88-5.6-4.06a37,37,0,1,0,68.74-6.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bird",
    className: "cls-2",
    d: "M7,30.77c5,5.51,12.22,15.58,28.42,15.81-2,1.8-7.64,3.65-10.7,4.07C28.53,54.22,34.41,52,39,49.39a30.46,30.46,0,0,1,14.69-3.87C53,42.9,49.23,44,46.65,44.08h-1.2a2.63,2.63,0,0,1-.77-.23l1.26-.52C56.1,39.54,64.85,28.54,70.13,20.55a35.57,35.57,0,0,0-3.78-6c-9.52,1.74-12.6,15.68-18,22.59-7.16,10.08-14,7.85-21.27,1.13S14.44,19.61,6.77,15.54A37.06,37.06,0,0,0,1.38,26.72C3.34,26.91,5.21,28.68,7,30.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Sky",
    className: "cls-3",
    d: "M27.1,38.26c7.22,6.72,14.11,8.92,21.28-1.14,5.45-6.91,8.5-20.85,18-22.59a37,37,0,0,0-59.58,1C14.49,19.61,19.88,31.65,27.1,38.26Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Wordmark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.45,24h1.94V16.25a2.06,2.06,0,0,0-2.25-1.87h-4V24h1.95V16.25h1.78c.38,0,.59.26.59.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.7,24V16.25a2.07,2.07,0,0,1,1.94-1.87h2.41A1.87,1.87,0,0,1,44,16.17V24H42.05V20.38H39.64V24ZM42.05,17a.69.69,0,0,0-.68-.7h-1a.72.72,0,0,0-.66.7v1.58h2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.48,24V16.25a2.08,2.08,0,0,1,2-1.87H49.8a1.87,1.87,0,0,1,1.94,1.79V24H49.8V20.38H47.43V24ZM49.8,17a.69.69,0,0,0-.68-.7h-1a.71.71,0,0,0-.64.7v1.58H49.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.22,14.38H31.84a1.93,1.93,0,0,0-1.95,1.85v6A2.19,2.19,0,0,0,31.84,24h2.38a2.24,2.24,0,0,0,1.94-1.8v-6a1.89,1.89,0,0,0-1.93-1.85Zm0,7.2a.63.63,0,0,1-.63.63H32.48a.62.62,0,0,1-.64-.62h0V16.83a.63.63,0,0,1,.63-.63h1.11a.63.63,0,0,1,.64.61v4.77Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoaaDigitalLogo);
export default __webpack_public_path__ + "static/media/noaa_digital_logo.1b5937521473d730cb4454813cad596a.svg";
export { ForwardRef as ReactComponent };